import React, { useCallback } from "react";
import { OpenWith } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";

import { registerPortalTarget } from "fond/layout/SubLayoutPopout";

import { ITabProps } from "./factory";

/**
 * Generic widget that acts as a portal target for SubLayoutPopout.
 * Renders an empty container whose DOM element is registered so that
 * SubLayoutPopout can portal its children into it.
 */
export const Widget: React.FC<ITabProps> = ({ node }) => {
  const ref = useCallback(
    (el: HTMLElement | null) => {
      registerPortalTarget(node.getId(), el);
    },
    [node]
  );

  return <Box ref={ref} height="100%" />;
};

export const Icon: React.FC<ITabProps> = () => (
  <Tooltip title="Popout" arrow placement="right">
    <OpenWith />
  </Tooltip>
);
